import { useEffect, useState } from 'react';
import { Banner, Footer, Navbar } from '../components';
import { Typography } from '@material-tailwind/react';


const ORGANIZING_COMMITTEE = [
  "João C. Neves, UBI, NOVA-LINCS",
  "Hugo Proença, UBI, Instituto de Telecomunicações",
  "Luís Alexandre, UBI, NOVA-LINCS",
  "Paulo Fazendeiro, UBI, Instituto de Telecomunicações",
  "Vasco Lopes, UBI, NOVA-LINCS",
  "Cristiano Patrício, UBI, NOVA-LINCS",
  "Bruno Degardin, UBI, Instituto de Telecomunicações",
]

const SCIENTIFIC_COMMITTEE = [
  "Luís Alexandre, UBI and NOVA LINCS",
  "Ana Oliveira Alves, Instituto Politécnico de Coimbra",
  "António Anjos, Universidade de Évora",
  "Francisco Antunes, University of Coimbra",
  "Mário Antunes, Instituto Politécnico de Leiria",
  "Helder Araujo, University of Coimbra",
  "Cristiana Manuela Areias, Instituto Superior de Engenharia de Coimbra",
  "Joel Arrais, University of Coimbra",
  "Nuno Cid Martins, ISEC - IPC",
  "António Cunha, UTAD & INESC tec",
  "Paulo Dias, University of Aveiro",
  "Inês Domingues, ISEC-IPC",
  "Sérgio Faria, Politecnico de Leiria / Instituto de Telecomunicações",
  "Pedro Miguel Gago, Politécnico de Leiria",
  "Petia Georgieva, IEEE European Public Policy Initiative - Working Group on ICT",
  "Rui Gomes, Faculdade de Ciencias e Tecnologia da Universidade de Coimbra",
  "Lio Gonçalves, UTAD",
  "Teresa Goncalves, Universidade de Évora",
  "Fernando Lopes, IPC/ISEC",
  "Bernardo Marques, IEETA, DETI, University of Aveiro",
  "Pedro Martins, Institute of Systems and Robotics, University of Coimbra",
  "Ana Mendonca, FEUP - Faculty of Engineering of the University of Porto",
  "Fernando Monteiro, Instituto Politécnico de Bragança",
  "Antonio Neves, University of Aveiro",
  "Hélder Oliveira, INESC TEC / FCUP",
  "Simão Paredes, Polytechnic Institute of Coimbra, Coimbra Institute of Engineering",
  "César Páris, Polytechnic Institute of Coimbra",
  "Carlos Pereira, IPC-ISEC",
  "Francisco Pereira, Polytechnic Institute of Coimbra",
  "Pedro Pina, University of Coimbra",
  "Hugo Plácido da Silva, IT - Instituto de Telecomunicações",
  "Diogo Pratas, University of Aveiro",
  "Francesco Renna, Universidade do Porto",
  "Teresa Rocha, Instituto Politécnico de Coimbra / Instituto Superior de Engenharia de Coimbra",
  "João M.F. Rodrigues, University of the Algarve",
  "Jose Saias, Universidade de Evora",
  "Pedro Salgueiro, Universidade de Évora",
  "Jorge Santos, ISEP",
  "Catarina Silva, University of Coimbra",
  "Jose Silvestre Silva, CINAMIL",
  "Luis Teixeira, Faculdade de Engenharia da Universidade do Porto",
  "Verónica Vasconcelos, ISEC - IPC"
]
export function Committees() {
  const [navbarTransparent, setNavbarTransparent] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      // Set navbar to not transparent if the scroll position is more than 100px
      const shouldNavbarBeTransparent = window.scrollY < 100;
      setNavbarTransparent(shouldNavbarBeTransparent);
    };

    // Add event listener for scroll
    window.addEventListener('scroll', handleScroll);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <div className="w-full relative">
        <Navbar transparent={navbarTransparent} />
        <Banner title={"Committees"} />

        <section className="w-full container mx-auto py-12 px-14" >

          <div className="flex flex-col justify-center  w-full h-full p-8">
            <Typography variant="h3" color="blue-gray" className="mb-2">
              Committees
            </Typography>
            <Typography color="gray" className="font-bold mt-2">
              Organizing Committee:
            </Typography>

            <ul className="list-disc font-normal mt-4" >
              {ORGANIZING_COMMITTEE.map((item) => (
                <li className="font-normal">
                  {item}
                </li>
              ))}
            </ul>

            <Typography color="gray" className="font-bold mt-8">
              Scientific Committee:
            </Typography>

            <ul className="list-disc font-normal mt-4" >
              {SCIENTIFIC_COMMITTEE.map((item) => (
                <li>
                  {item}
                </li>
              ))}
            </ul>

          </div>

        </section>
        <Footer />

      </div>
    </>
  );
}
